export const currency = "EUR";
export const defaultCountryCode = "FR";
export const language = "fr";
export const timeZone = "Europe/Paris";

export const countryNames = new Intl.DisplayNames(language, {
  type: "region",
});

export const currencyFormatter = new Intl.NumberFormat(language, {
  currency,
  style: "currency",
});

export const percentFormatter = new Intl.NumberFormat(language, {
  minimumFractionDigits: 0,
  style: "percent",
});

export const numberFormatter = new Intl.NumberFormat(language);

export function monthAndYear(dateString: string): string {
  return new Date(dateString).toLocaleDateString(language, {
    month: "long",
    timeZone,
    year: "numeric",
  });
}
